import { render, staticRenderFns } from "./divider-tertiary.vue?vue&type=template&id=2bcc6bc1&scoped=true"
import script from "./divider-tertiary.vue?vue&type=script&lang=js"
export * from "./divider-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc6bc1",
  null
  
)

export default component.exports